/*
 * @Author: bianbinbin
 * @Date: 2024-03-06 18:57:36
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-06-26 17:42:13
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/aboutBaggage.js
 */

const connectingFlightList = r => require.ensure([], () => r(require('@/views/aboutBaggage/connectingFlightList.vue'), 'connectingFlightList'))
const baggageDetail = r => require.ensure([], () => r(require('@/views/aboutBaggage/baggageDetail.vue'), 'baggageDetail'))
const connectingBaggageList = r => require.ensure([], () => r(require('@/views/aboutBaggage/connectingBaggageList.vue'), 'connectingBaggageList'))
const router = [
  {
    path: '/connectingBaggageList',
    name: 'connectingBaggageList',
    meta: {
      title: '中转行李列表'
    },
    component: connectingBaggageList
  },
  {
    path: '/baggageDetail',
    name: 'baggageDetail',
    meta: {
      title: '行李明细'
    },
    component: baggageDetail
  },
  {
    path: '/connectingFlightList',
    name: 'connectingFlightList',
    meta: {
      title: '中转航班列表'
    },
    component: connectingFlightList
  }
]

export default router
